// Global Types
import type {
  $FullBanner,
} from 'common.data';

// Global Enums
import {
  webPages,
  webSections,
} from 'common.enums';

// Global Components
import * as React from 'react';

// Helpers
import {
  isDiff,
} from '@vroskus/library-helpers/dist/browser';
import ErrorLog from '@vroskus/library-sentry/dist/browser';

// Services
import Services from '../../../../services';

// Components
import BannersSection from '../../CommonSections/BannersSection';

// Types
type $Props = {
  RegionSeasonId: string;
};

type $State = {
  data: Array<$FullBanner>;
};

class BannersSectionView extends React.Component<$Props, $State> {
  constructor(props: $Props) {
    super(props);

    this.state = {
      data: [],
    };
  }

  componentDidMount(): void {
    this.getData();
    this.setupSocket();
  }

  componentDidUpdate(prevProps: $Props): void {
    const {
      RegionSeasonId,
    } = this.props;

    if (isDiff(
      prevProps.RegionSeasonId,
      RegionSeasonId,
    )) {
      this.getData();
    }
  }

  setStateAsync(state: Partial<$State>): Promise<void> {
    return new Promise((resolve) => {
      this.setState(
        (pervState: $State) => ({
          ...pervState,
          ...state,
        }),
        resolve,
      );
    });
  }

  async getData(): Promise<void> {
    const {
      RegionSeasonId,
    } = this.props;

    try {
      const data = await Services.Api.getRegattasBannersSectionData({
        RegionSeasonId,
      });

      await this.setStateAsync({
        data,
      });
    } catch (err) {
      const error = err as Error;

      ErrorLog.exception(error);
    }
  }

  setupSocket(): void {
    const {
      RegionSeasonId,
    } = this.props;

    Services.Socket.on({
      action: (data) => {
        if (data.RegionSeasonId === RegionSeasonId && data.modelName === 'Banner') {
          this.getData();
        }
      },
      type: Services.Socket.type.modelChangedEvent,
    });
  }

  render() {
    const {
      data,
    } = this.state;

    return (data.length > 0 ? (
      <BannersSection
        data={data}
        id={webSections[webPages.regattasPage].banners}
      />
    ) : null);
  }
}

export default BannersSectionView;
